export {
  ChatContextProvider,
  useChatContext,
} from "@/components/aios-assistant/context/chat-context";
export type {
  ChatContextType,
  PageContext,
} from "@/components/aios-assistant/context/chat-context";
